import type { ChecklistTemplate, Machine, ChecklistItem, LubricantSpec } from '../types';

export const TOS_VARNSDORF_LUBRICANTS: LubricantSpec[] = [
  {
    symbol: 'O - HM 46',
    code: 'O - HM 46',
    name: 'น้ำมันไฮดรอลิกมาตรฐาน (Hydraulic Oil)',
    description: 'น้ำมันไฮดรอลิกมาตรฐาน (Hydraulic Oil)',
    specification: 'ISO VG 46 DIN 51 524 / part 2',
    equivalents: ['Castrol Hyspin AWS 46', 'Shell Tellus S2 M 46', 'Mobil DTE 25'],
    points: 'ถังน้ำมันไฮดรอลิกส่วนกลาง (จุดที่ 3), ชุดสร้างไฮดรอลิก (จุดที่ 22)',
    intervalAndQuantity: 'เติมเมื่อต่ำกว่าตาแมว / เปลี่ยนถ่ายทุก 2,000 ชม.',
  },
  {
    symbol: 'O - G 220',
    code: 'O - G 220',
    name: 'น้ำมันหล่อลื่นรางเลื่อนและเกียร์ (Slideways & Gearbox Oil)',
    description: 'น้ำมันหล่อลื่นรางเลื่อนและเกียร์ (Slideways & Gearbox)',
    specification: 'ISO VG 220 DIN 51 502 - CGLP',
    equivalents: ['Castrol Magna BD 68 / Magna CF 220', 'Shell Tonna S3 M 220', 'Mobil Vactra Oil No. 4'],
    points: 'ชุดถังหล่อลื่นรางเลื่อนส่วนกลาง (จุดที่ 12), ห้องเกียร์โต๊ะหมุน (จุดที่ 30)',
    intervalAndQuantity: 'เติมเมื่อต่ำกว่าเกณฑ์ / เปลี่ยนถ่ายทุก 2,000 ชม.',
  },
  {
    symbol: 'Klüber NBU 15',
    code: 'Klüber NBU 15',
    name: 'จาระบีสปินเดิลรอบสูง (Spindle Bearing Grease)',
    description: 'จาระบีสปินเดิลรอบสูง (Spindle Grease)',
    specification: 'Klüber Isoflex NBU 15',
    equivalents: ['แนะนำให้ใช้ยี่ห้อนี้โดยตรงตามคู่มือ', 'ห้ามใช้จาระบีเอนกประสงค์ทั่วไปเด็ดขาด'],
    points: 'ตลับลูกปืนหลักของเพลาหมุนหัวเครื่อง (Main Headstock Bearings - จุดที่ 10)',
    intervalAndQuantity: 'เปลี่ยนสารหล่อลื่นและจาระบีทุกๆ 8,000 ชม.',
  },
  {
    symbol: 'Castrol AP2',
    code: 'Castrol AP2',
    name: 'จาระบีอเนกประสงค์เกรดพิเศษ (Lithium Grease EP 2)',
    description: 'จาระบีอเนกประสงค์เกรดพิเศษ (Lithium EP 2)',
    specification: 'ISO-L-XBCHA 2 DIN 51 502 / KP2K-25',
    equivalents: ['Castrol Spheerol AP 2', 'Mobilux EP 2', 'Shell Gadus S2 V220 2'],
    points: 'ชุดเกลียวบอลสกรูแกนต่างๆ (จุดที่ 1), ตลับลูกปืนเชิงเส้นของแกนและชุดลูกปืน',
    intervalAndQuantity: 'อัดครั้งละ 100 กรัม / ทุกๆ 1,000 ชม. สะสม',
  },
  {
    symbol: 'Molykote DX',
    code: 'Molykote DX',
    name: 'สารหล่อลื่นแบบสีขาวชนิดพิเศษ (White Lubrication Paste)',
    description: 'สารหล่อลื่นสีขาวชนิดพิเศษ (White Paste)',
    specification: 'MOLYKOTE® DX Paste',
    equivalents: ['แนะนำให้ใช้ยี่ห้อนี้โดยตรงตามคู่มือ'],
    points: 'ผิวหน้าเตเปอร์และช่องเรียวเพลาหลัก (Spindle Taper - ตรวจบำรุงรักษาทุกเดือน)',
    intervalAndQuantity: 'ชะโลมผิวให้ทั่วถึง / ทุกๆ เดือน',
  },
];

export const TOS_VARNSDORF_SAFETY_CAUTIONS: string[] = [
  'ห้ามใช้ลมเป่า (Air Blow) แรงดันสูงบริเวณฝาครอบสไลด์เวย์และหน้าสัมผัสของแกนต่างๆ เพราะจะพัดเศษโลหะเข้าไปขัดในรางเลื่อนชำรุดเสียหาย',
  'น้ำมันหล่อลื่นที่ระบุตามมาตรฐานผู้ผลิต (TOS Varnsdorf) ในตารางข้างต้นได้รับการออกแบบสำหรับความต้านทานแรงเค้นของผิววัสดุเครื่องจักรโดยเฉพาะ การผสมแบรนด์หรือเปลี่ยนประเภทอาจทำให้ประสิทธิภาพการปกป้องรางเลื่อนและรางสไลด์ลดลงจนเป็นเหตุให้แกนฝืดขัดตัวได้ (Motor Blocked)',
  'ในกรณีที่ปล่อยให้น้ำมันในชุดหล่อลื่นรางเลื่อนส่วนกลางลดระดับจนเกลี้ยงถัง หรือมีฟองอากาศเข้าไปค้างในระบบท่อส่งน้ำมัน ระบบจะแสดงเตือนระบบหล่อลื่นล้มเหลว (Lubrication Pressure Failure 1.8 MPa) ต้องทำแมนนวลหล่อลื่นเพื่อไล่ลม (Discharge Air) ทุกแกนจนกว่าสายแรงดันปกติ',
  'แกน W มีกลไกการหล่อลื่นแยกกัน 2 จุด: รางสไลด์หล่อลื่นด้วยน้ำมัน VG 220 จากชุดควบคุมส่วนกลาง แต่ตลับลูกปืนบอลสกรูแกน W ต้องได้รับการอัดจาระบีด้วยมือ (Castrol AP2) ที่หัวแกนด้านท้ายเครื่องทุกๆ 1,000 ชั่วโมงการทำงาน',
  'ก่อนเปิดเครื่องรันโปรแกรม หรือทำ PM ทุกครั้ง จะต้องตรวจสอบให้มั่นใจว่าระดับแรงดันไฮดรอลิกปกติไม่ต่ำกว่า 6.8 MPa (68 bar) เพื่อป้องกันไม่ให้เกิดความเสียหายกับชุดปลดเบรกแกนทางกลและ Spindle',
];

export const TOS_VARNSDORF_ITEMS: ChecklistItem[] = [
  // =========================================================================
  // DAILY & SHIFT (9 ITEMS)
  // =========================================================================
  {
    id: 'D-01',
    itemNo: 1,
    frequency: 'DAILY',
    taskNameTh: 'ทำความสะอาดเศษโลหะ (Chips) และน้ำยาหล่อเย็นรอบบริเวณเครื่องจักรและรางเลื่อนหลังจบวัน (ห้ามใช้ลมเป่าแรงดันสูงบริเวณรางเลื่อนโดยตรง)',
    taskNameEn: 'Clean chips and coolant around machine and slideways after shift (Do not use high-pressure air blow)',
    criteriaTh: 'สะอาด ไม่มีเศษเหล็กค้างสะสม',
    criteriaEn: 'Clean, no accumulated metal chips',
    methodTh: 'แมนนวล (Manual)',
    methodEn: 'Manual cleaning',
    inputType: 'done_checkbox',
    mandatory: true,
  },
  {
    id: 'D-02',
    itemNo: 2,
    frequency: 'DAILY',
    taskNameTh: 'ตรวจสอบระดับน้ำมันหล่อลื่นที่หัวเครื่อง (Headstock Oil Level) ผ่านเกจวัดตาแมว',
    taskNameEn: 'Check headstock oil level through sight glass',
    criteriaTh: 'ระดับไม่ต่ำกว่าขีดกลาง/ขีดต่ำสุด (เติมน้ำมัน HM 46 หากจำเป็น)',
    criteriaEn: 'Level not below mid/min line (refill HM 46 if needed)',
    methodTh: 'สายตา (Visual)',
    methodEn: 'Visual check',
    inputType: 'select_option',
    options: ['ปกติ', 'เติมเพิ่ม'],
    mandatory: true,
  },
  {
    id: 'D-03',
    itemNo: 3,
    frequency: 'DAILY',
    taskNameTh: 'เช็กระดับน้ำมันในถังหล่อลื่นรางเลื่อนส่วนกลาง (Central Lubrication Set)',
    taskNameEn: 'Check oil level in central slideway lubrication reservoir',
    criteriaTh: 'ระดับไม่ต่ำกว่าขีดต่ำสุด (เติมน้ำมันประเภท G 220)',
    criteriaEn: 'Level not below minimum line (refill G 220)',
    methodTh: 'สายตา (Visual)',
    methodEn: 'Visual check',
    inputType: 'select_option',
    options: ['ปกติ', 'เติมเพิ่ม'],
    mandatory: true,
  },
  {
    id: 'D-04',
    itemNo: 4,
    frequency: 'DAILY',
    taskNameTh: 'ตรวจสอบแรงดันระบบไฮดรอลิกขณะเครื่องจักรทำงานปกติ (Hydraulic System Pressure)',
    taskNameEn: 'Check hydraulic system pressure during normal operation',
    criteriaTh: 'ต้องไม่ต่ำกว่า 6.8 MPa (หรือ 68 bar)',
    criteriaEn: 'Must not be lower than 6.8 MPa (68 bar)',
    methodTh: 'เกจวัด (MPa)',
    methodEn: 'Pressure gauge (MPa)',
    inputType: 'numeric_gauge',
    unit: 'MPa',
    minValue: 6.8,
    criticalLimit: {
      operator: '<',
      value: 6.8,
      warningMessage: 'CRITICAL: Hydraulic pressure < 6.8 MPa (68 bar) below safety threshold!',
    },
    mandatory: true,
  },
  {
    id: 'D-05',
    itemNo: 5,
    frequency: 'DAILY',
    taskNameTh: 'ตรวจสอบแรงดันน้ำมันหล่อลื่นหัวเครื่องขณะหล่อลื่นปกติ',
    taskNameEn: 'Check headstock lubrication pressure during normal operation',
    criteriaTh: 'ต้องอยู่ที่ประมาณ 0.8 MPa (ช่วงปกติ 0.6 - 1.1 MPa)',
    criteriaEn: 'Must be approximately 0.8 MPa (normal range 0.6 - 1.1 MPa)',
    methodTh: 'เกจวัด (MPa)',
    methodEn: 'Pressure gauge (MPa)',
    inputType: 'numeric_gauge',
    unit: 'MPa',
    minValue: 0.6,
    maxValue: 1.1,
    criticalLimit: {
      operator: '<',
      value: 0.6,
      warningMessage: 'แรงดันน้ำมันหล่อลื่นหัวเครื่องผิดปกติ (< 0.6 MPa หรือ > 1.1 MPa)',
    },
    mandatory: true,
  },
  {
    id: 'D-06',
    itemNo: 6,
    frequency: 'DAILY',
    taskNameTh: 'ตรวจสอบแรงดันน้ำมันหล่อลื่นหัวเครื่องขณะเปลี่ยนระดับเกียร์ (Gear Shifting)',
    taskNameEn: 'Check headstock lubrication pressure during gear shifting',
    criteriaTh: 'ต้องอยู่ที่ประมาณ 2.5 - 3.5 MPa',
    criteriaEn: 'Must be between 2.5 and 3.5 MPa',
    methodTh: 'เกจวัด (MPa)',
    methodEn: 'Pressure gauge (MPa)',
    inputType: 'numeric_gauge',
    unit: 'MPa',
    minValue: 2.5,
    maxValue: 3.5,
    criticalLimit: {
      operator: '<',
      value: 2.5,
      warningMessage: 'แรงดันเปลี่ยนเกียร์อยู่นอกเกณฑ์มาตรฐาน (2.5 - 3.5 MPa)',
    },
    mandatory: true,
  },
  {
    id: 'D-07',
    itemNo: 7,
    frequency: 'DAILY',
    taskNameTh: 'ตรวจสอบการรั่วซึมของข้อต่อทางหมุนน้ำยาหล่อเย็น (Deublin Rotary Inlet) ที่ท้ายเพลาหลัก',
    taskNameEn: 'Check for leaks at Deublin rotary coolant inlet at rear of main spindle',
    criteriaTh: 'ต้องไม่มีคราบน้ำมันหรือหล่อเย็นรั่วซึมหยดลงพื้น',
    criteriaEn: 'No oil or coolant leakage dripping to floor',
    methodTh: 'สายตา (Visual)',
    methodEn: 'Visual check',
    inputType: 'select_option',
    options: ['ปกติ', 'รั่วซึม'],
    mandatory: true,
  },
  {
    id: 'D-08',
    itemNo: 8,
    frequency: 'DAILY',
    taskNameTh: 'ทำความสะอาดเรียวเพลาหมุนหลัก (Spindle Taper) ด้วยแปรงเฉพาะ และตรวจเช็กเบ้าทูลในแมกกาซีน',
    taskNameEn: 'Clean spindle taper with special brush and inspect tool magazine sockets',
    criteriaTh: 'ไม่มีคราบเขม่าหรือเศษชิปสะสม',
    criteriaEn: 'Free of soot, residue, or chips',
    methodTh: 'สายตา (Visual)',
    methodEn: 'Visual / Manual cleaning',
    inputType: 'done_checkbox',
    mandatory: true,
  },
  {
    id: 'D-09',
    itemNo: 9,
    frequency: 'DAILY',
    taskNameTh: 'ตรวจสอบระดับน้ำมันหล่อเย็น (Coolant Level) ในถังพักหล่อเย็น',
    taskNameEn: 'Check coolant level in coolant reservoir',
    criteriaTh: 'ระดับอยู่ในเกณฑ์ 70-90% ของถังพัก',
    criteriaEn: 'Level within 70-90% of reservoir capacity',
    methodTh: 'สายตา (Visual)',
    methodEn: 'Visual check',
    inputType: 'select_option',
    options: ['ปกติ', 'เติมเพิ่ม'],
    mandatory: true,
  },

  // =========================================================================
  // WEEKLY (3 ITEMS)
  // =========================================================================
  {
    id: 'W-01',
    itemNo: 1,
    frequency: 'WEEKLY',
    taskNameTh: 'ตรวจเช็ก ทำความสะอาด และตรวจรอยบุบของฝาครอบสไลด์เวย์แบบยืดหด (Telescopic Covers - TSA)',
    taskNameEn: 'Inspect, clean, and check for dents on telescopic slideway covers (TSA)',
    criteriaTh: 'ผิวฝาครอบสะอาด ไม่มีรอยบุบหนักขัดขวางการยืดหด',
    criteriaEn: 'Cover surface clean, no heavy dents obstructing movement',
    methodTh: 'สายตา (Visual)',
    methodEn: 'Visual check',
    inputType: 'select_option',
    options: ['ปกติ', 'ชำรุด'],
    mandatory: true,
  },
  {
    id: 'W-02',
    itemNo: 2,
    frequency: 'WEEKLY',
    taskNameTh: 'ตรวจเช็กและระบายน้ำค้างที่ตัวดักไอน้ำ/ฟิลเตอร์กรองอากาศในชุดนิวเมติกส์ (Air Unit Filter)',
    taskNameEn: 'Check and drain condensate moisture from pneumatic air unit filter water trap',
    criteriaTh: 'ไม่มีน้ำค้างสะสมเหลือค้างอยู่ในถ้วยดักน้ำ',
    criteriaEn: 'No accumulated condensate remaining in water trap',
    methodTh: 'แมนนวล (Manual)',
    methodEn: 'Manual drain',
    inputType: 'done_checkbox',
    mandatory: true,
  },
  {
    id: 'W-03',
    itemNo: 3,
    frequency: 'WEEKLY',
    taskNameTh: 'ตรวจสอบสภาพแผ่นยางปัดฝุ่นรางสไลด์และยางกวาดเศษโลหะ (Guide surface wipers)',
    taskNameEn: 'Check condition of slideway wiper seals and scrapers',
    criteriaTh: 'ยางแนบสนิท ไม่มีรอยฉีกขาดหรือคราบยางเสื่อมสภาพ',
    criteriaEn: 'Wiper rubber flush against guideways, no tears or degradation',
    methodTh: 'สายตา (Visual)',
    methodEn: 'Visual check',
    inputType: 'select_option',
    options: ['ปกติ', 'ชำรุด'],
    mandatory: true,
  },

  // =========================================================================
  // MONTHLY (5 ITEMS)
  // =========================================================================
  {
    id: 'M-01',
    itemNo: 1,
    frequency: 'MONTHLY',
    taskNameTh: 'ยืดแกน W ออกมาให้สุด ทำความสะอาดผิวเพลาหลักอย่างละเอียด และทาสารหล่อลื่นชะโลมเคลือบผิว',
    taskNameEn: 'Fully extend W-axis, clean spindle surface thoroughly, and coat with lubricant',
    criteriaTh: 'ทาสารหล่อลื่นประเภท MOLYKOTE DX ที่ผิวหน้าและโพรง Spindle สม่ำเสมอ',
    criteriaEn: 'Evenly apply Molykote DX paste on spindle surface and bore',
    methodTh: 'แมนนวล (Manual)',
    methodEn: 'Manual application',
    inputType: 'done_checkbox',
    mandatory: true,
  },
  {
    id: 'M-02',
    itemNo: 2,
    frequency: 'MONTHLY',
    taskNameTh: 'คลายเกลียวปลั๊กอุดใต้หัวเครื่อง (ใช้ประแจหกเหลี่ยมเบอร์ 6) เพื่อถ่ายระบายน้ำมันหล่อลื่นที่รั่วสะสมจากแกน W ทิ้ง',
    taskNameEn: 'Unscrew drain plug under headstock (Hex 6mm) to drain accumulated W-axis leaked oil',
    criteriaTh: 'ถ่ายน้ำมันรั่วไหลส่วนเกินออกจากอ่างดัก (W axis leakage pit) จนหมดและปิดปลั๊กแน่น',
    criteriaEn: 'Drain all accumulated excess oil from pit and tighten plug securely',
    methodTh: 'แมนนวล (Manual)',
    methodEn: 'Manual drain',
    inputType: 'done_checkbox',
    mandatory: true,
  },
  {
    id: 'M-03',
    itemNo: 3,
    frequency: 'MONTHLY',
    taskNameTh: 'ตรวจเช็กความตึง รอยฉีกขาด และสภาพของลวดสลิงถ่วงน้ำหนักหัวเครื่อง (Headstock counter-balancing suspension ropes)',
    taskNameEn: 'Check tension, fraying, and condition of headstock counter-balance wire ropes',
    criteriaTh: 'ลวดสลิงตึงเท่ากัน ไม่มีเส้นลวดฝอยขาดหรือชำรุด และทำการอัดจาระบี XCCEB 3',
    criteriaEn: 'Ropes evenly tensioned, no broken strands, grease with XCCEB 3',
    methodTh: 'สายตา/วัด',
    methodEn: 'Visual / Measurement',
    inputType: 'select_option',
    options: ['ปกติ', 'อัดจาระบีแล้ว'],
    mandatory: true,
  },
  {
    id: 'M-04',
    itemNo: 4,
    frequency: 'MONTHLY',
    taskNameTh: 'เช็กระดับน้ำมันหล่อลื่นในชุดห้องเกียร์โต๊ะหมุน (Table drive gearbox)',
    taskNameEn: 'Check lubricant level in rotary table drive gearbox',
    criteriaTh: 'ระดับน้ำมันกึ่งกลางตาแมว (หากต่ำกว่าให้เติมน้ำมันประเภท G 220)',
    criteriaEn: 'Oil level at center of sight glass (refill G 220 if below)',
    methodTh: 'สายตา (Visual)',
    methodEn: 'Visual check',
    inputType: 'select_option',
    options: ['ปกติ', 'เติมเพิ่ม'],
    mandatory: true,
  },
  {
    id: 'M-05',
    itemNo: 5,
    frequency: 'MONTHLY',
    taskNameTh: 'ตรวจสอบสถานะการอุดตันของไส้กรองน้ำมันไฮดรอลิก (Hydraulic filter block indicator)',
    taskNameEn: 'Check hydraulic oil filter clogging indicator status',
    criteriaTh: 'เข็มเกจหรือไฟสถานะสีแดงต้องไม่แสดงเตือนการอุดตัน',
    criteriaEn: 'Clog indicator or red flag must not indicate blockage',
    methodTh: 'สายตา (Visual)',
    methodEn: 'Visual indicator check',
    inputType: 'select_option',
    options: ['ปกติ', 'อุดตัน'],
    mandatory: true,
  },

  // =========================================================================
  // YEARLY & OPERATING HOURS (9 ITEMS)
  // =========================================================================
  {
    id: 'H-01',
    itemNo: 1,
    frequency: 'HOURS',
    hoursThreshold: 500,
    taskNameTh: '[ทุก 500 ชม.] ตรวจสอบฟิล์มน้ำมันหล่อลื่นที่รางเลื่อนและบอลสกรูด้วยสายตา',
    taskNameEn: '[Every 500 h] Visually check lubricating oil film on slideways and ballscrews',
    criteriaTh: 'ผิวสไลด์เวย์และเพลาบอลสกรูต้องมีฟิล์มน้ำมันบางๆ เคลือบชุ่มชื้นตลอดแนว',
    criteriaEn: 'Guideways and ballscrews must have thin moist oil film along entire length',
    methodTh: 'สายตา (Visual)',
    methodEn: 'Visual check',
    inputType: 'select_option',
    options: ['มีฟิล์มน้ำมัน', 'แห้งผิดปกติ'],
    mandatory: true,
  },
  {
    id: 'H-02',
    itemNo: 2,
    frequency: 'HOURS',
    hoursThreshold: 1000,
    taskNameTh: '[ทุก 1,000 ชม.] หล่อลื่นรางเลื่อน และอัดจาระบีที่หัวเกลียวบอลสกรูของแกนต่างๆ (รวมถึงแกน W)',
    taskNameEn: '[Every 1,000 h] Lubricate slideways and grease ballscrew nuts of all axes (including W-axis)',
    criteriaTh: 'อัดจาระบีประเภท Castrol AP2 (ปริมาณ 100 กรัม) เข้าหัวอัดจาระบีบอลสกรู',
    criteriaEn: 'Pump Castrol AP2 grease (100g) into ballscrew grease nipples',
    methodTh: 'แมนนวล (Manual)',
    methodEn: 'Manual grease gun',
    inputType: 'done_checkbox',
    mandatory: true,
  },
  {
    id: 'H-03',
    itemNo: 3,
    frequency: 'HOURS',
    hoursThreshold: 2000,
    taskNameTh: '[ทุก 2,000 ชม.] เปลี่ยนถ่ายน้ำมันไฮดรอลิกทั้งหมดพร้อมทำความสะอาดถังไฮดรอลิก',
    taskNameEn: '[Every 2,000 h] Completely drain and replace hydraulic oil, clean reservoir tank',
    criteriaTh: 'เปลี่ยนถ่ายน้ำมันไฮดรอลิกใหม่ทั้งหมด ใช้ประเภทมาตรฐาน O - HM 46',
    criteriaEn: 'Completely replace with fresh hydraulic oil standard O - HM 46 (ISO VG 46)',
    methodTh: 'เปลี่ยนถ่าย (Drain & Flush)',
    methodEn: 'Drain & flush',
    inputType: 'select_option',
    options: ['เปลี่ยนแล้ว', 'ดำเนินการต่อ'],
    mandatory: true,
  },
  {
    id: 'H-04',
    itemNo: 4,
    frequency: 'HOURS',
    hoursThreshold: 2000,
    taskNameTh: '[ทุก 2,000 ชม.] เปลี่ยนถ่ายน้ำมันในชุดระบบหล่อลื่นรางเลื่อนส่วนกลาง (Central Lubrication Unit)',
    taskNameEn: '[Every 2,000 h] Drain and replace oil in central slideway lubrication reservoir',
    criteriaTh: 'เปลี่ยนถ่ายน้ำมันหล่อลื่นใหม่ทั้งหมด ใช้ประเภทมาตรฐาน O - G 220',
    criteriaEn: 'Completely replace with fresh lubricant standard O - G 220 (ISO VG 220)',
    methodTh: 'เปลี่ยนถ่าย (Drain & Flush)',
    methodEn: 'Drain & flush',
    inputType: 'select_option',
    options: ['เปลี่ยนแล้ว', 'ดำเนินการต่อ'],
    mandatory: true,
  },
  {
    id: 'H-05',
    itemNo: 5,
    frequency: 'HOURS',
    hoursThreshold: 2000,
    taskNameTh: '[ทุก 2,000 ชม.] เปลี่ยนถ่ายน้ำมันในห้องเกียร์โต๊ะหมุน (Rotary Table Gear Box)',
    taskNameEn: '[Every 2,000 h] Drain and replace oil in rotary table gearbox',
    criteriaTh: 'เปลี่ยนถ่ายน้ำมันใหม่ทั้งหมด ใช้ประเภทมาตรฐาน O - G 220',
    criteriaEn: 'Completely replace with fresh gear oil standard O - G 220 (ISO VG 220)',
    methodTh: 'เปลี่ยนถ่าย (Drain & Flush)',
    methodEn: 'Drain & flush',
    inputType: 'select_option',
    options: ['เปลี่ยนแล้ว', 'ดำเนินการต่อ'],
    mandatory: true,
  },
  {
    id: 'H-06',
    itemNo: 6,
    frequency: 'HOURS',
    hoursThreshold: 2000,
    taskNameTh: '[ทุก 2,000 ชม.] ตรวจสอบและเปลี่ยนแผ่นยางกวาดรางเลื่อนรอบเครื่องจักร (Guide surface wipers)',
    taskNameEn: '[Every 2,000 h] Inspect and replace guideway wiper seal sets around machine',
    criteriaTh: 'ถอดเปลี่ยนแผ่นยางปัดฝุ่นรางสไลด์ชุดใหม่เพื่อป้องกันน้ำยาหล่อเย็นซึมเข้ารางเลื่อน',
    criteriaEn: 'Install new wiper seals to prevent coolant intrusion into guideways',
    methodTh: 'ถอดเปลี่ยน',
    methodEn: 'Replace wipers',
    inputType: 'select_option',
    options: ['ตรวจสอบแล้ว', 'เปลี่ยนใหม่'],
    mandatory: true,
  },
  {
    id: 'H-07',
    itemNo: 7,
    frequency: 'HOURS',
    hoursThreshold: 8000,
    taskNameTh: '[ทุก 8,000 ชม.] เปลี่ยนสารหล่อลื่น/จาระบีตลับลูกปืนหลัก Spindle (Main Bearings)',
    taskNameEn: '[Every 8,000 h] Replace spindle main bearing grease (High-speed bearings)',
    criteriaTh: 'อัดหรือเปลี่ยนจาระบีสำหรับลูกปืนสปินเดิลความเร็วสูงพิเศษ Klüber Isoflex NBU 15 (ห้ามใช้จาระบีทั่วไปเด็ดขาด)',
    criteriaEn: 'Repack with Klüber Isoflex NBU 15 high-speed spindle grease (strictly mandatory)',
    methodTh: 'เปลี่ยนถ่าย',
    methodEn: 'Drain & regrease',
    inputType: 'select_option',
    options: ['เปลี่ยนแล้ว', 'ดำเนินการต่อ'],
    mandatory: true,
  },
  {
    id: 'H-08',
    itemNo: 8,
    frequency: 'HOURS',
    hoursThreshold: 8000,
    taskNameTh: '[ทุก 8,000 ชม.] ตรวจเช็กและเปลี่ยนแบตเตอรี่สำรองระบบควบคุม NC (NCK Battery) ในตู้ไฟฟ้า',
    taskNameEn: '[Every 8,000 h] Check and replace NC control backup battery (NCK Battery) in cabinet',
    criteriaTh: 'เปลี่ยนแบตเตอรี่สำรองเพื่อป้องกันข้อมูลพารามิเตอร์ของระบบควบคุมสูญหายขณะปิดเครื่อง',
    criteriaEn: 'Replace backup battery to prevent CNC system parameter memory loss',
    methodTh: 'ถอดเปลี่ยน',
    methodEn: 'Replace battery',
    inputType: 'select_option',
    options: ['ตรวจสอบแรงดัน', 'เปลี่ยนใหม่'],
    mandatory: true,
  },
  {
    id: 'H-09',
    itemNo: 9,
    frequency: 'HOURS',
    hoursThreshold: 10000,
    taskNameTh: '[ทุก 10,000 ชม.] เปลี่ยนน้ำมันหล่อลื่นภายในชุดหัวกัดมิลลิ่งเสริม (HUR 50 / HUI 50 หากติดตั้ง)',
    taskNameEn: '[Every 10,000 h] Replace lubricating oil in auxiliary milling attachments (HUR 50 / HUI 50)',
    criteriaTh: 'เปลี่ยนถ่ายน้ำมันหล่อลื่นหัวกัดเสริมตามรอบชั่วโมงงาน',
    criteriaEn: 'Drain and refill specialized milling head gear oil according to operating hours',
    methodTh: 'เปลี่ยนถ่าย',
    methodEn: 'Drain & refill',
    inputType: 'select_option',
    options: ['เปลี่ยนแล้ว', 'ไม่มีอุปกรณ์นี้'],
    mandatory: true,
  },
];

export const TOS_VARNSDORF_WHNQ1315_TEMPLATE: ChecklistTemplate = {
  id: 'tpl_tos_whnq1315',
  name: 'TOS VARNSDORF WHN(Q) 13/15 Standard PM Checklist',
  machineModel: 'WHN(Q) 13/15',
  version: '1.0.0',
  isDefault: true,
  lubricants: TOS_VARNSDORF_LUBRICANTS,
  safetyCautions: TOS_VARNSDORF_SAFETY_CAUTIONS,
  items: TOS_VARNSDORF_ITEMS,
  createdAt: '2026-01-01T00:00:00.000Z',
  updatedAt: '2026-01-01T00:00:00.000Z',
};

export const DEFAULT_MACHINE: Machine = {
  id: 'CNC-01',
  name: 'TOS VARNSDORF WHN(Q) 13/15',
  model: 'WHN(Q) 13/15',
  serialNo: 'WHN-2023-001',
  location: 'Workshop Bay A',
  assignedTemplateId: 'tpl_tos_whnq1315',
  cumulativeHours: 1850.5,
  lastInspectionDate: new Date(Date.now() - 4 * 3600 * 1000).toISOString(),
  lastInspectionHours: 1842.0,
  status: 'NORMAL',
  createdAt: '2026-01-01T00:00:00.000Z',
  updatedAt: '2026-01-01T00:00:00.000Z',
};
